<script lang="ts">
	import type { ButtonType } from './types';
	import { tooltipAction, smoothScroll } from '$lib/actions';
	import { v4 as uuidv4 } from 'uuid';

	export let props: ButtonType = {};

	$: type = props.type || 'button';
	$: props.disabled = props.disabled || props.fetching;
</script>

{#if props.href}
	{#if props.disabled}
		<a
			id={props.id}
			class:link={!!props.href}
			class:disabled={props.disabled}
			class={props.classNames}
			use:tooltipAction={props.tooltip}
			bind:this={props.ref}
			on:click
			aria-label={props.ariaLabel ?? 'Link'}
		>
			<slot />
		</a>
	{:else}
		<a
			id={props.id}
			href={props.href}
			class:link={!!props.href}
			class={props.classNames}
			target={props.hrefTarget ? `_${props.hrefTarget}` : ''}
			use:tooltipAction={props.tooltip}
			use:smoothScroll={props.href}
			bind:this={props.ref}
			on:click
			aria-label={props.ariaLabel ?? 'Link'}
		>
			<slot />
		</a>
	{/if}
{:else}
	<button
		{...$$restProps}
		id={props.id ?? uuidv4()}
		aria-label={props.ariaLabel ?? 'Button'}
		{type}
		disabled={props.disabled}
		class:fetching={props.fetching}
		class:btn={!!type}
		class={props.classNames}
		on:click
		on:mousedown
		on:mouseup
		on:mouseleave
		use:tooltipAction={props.tooltip}
		bind:this={props.ref}
	>
		<slot />
	</button>
{/if}

<style lang="postcss">
	.link,
	.btn {
		@apply relative transition-colors disabled:opacity-50 disabled:cursor-not-allowed;
	}
</style>
